import React, { useState, useEffect } from "react";
import { ArrowRight } from "lucide-react";
import DevotionalCard from "./devotionalCard";
import { useDispatch } from "react-redux";
import { readDevotionalsAction } from "../../store/Group/action";

const DevotionalPlan = ({ onNext, onCreatePlan, onAddPlan }) => {
  const [activeTab, setActiveTab] = useState("Find Devotionals");
  const [searchText, setSearchText] = useState("");
  const [devotionals, setDevotionals] = useState([]);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  // Fetch devotionals on component mount
  useEffect(() => {
    fetchDevotionals();
  }, []);

  const fetchDevotionals = () => {
    setLoading(true);
    dispatch(
      readDevotionalsAction({
        callback: (res) => {
          if (res.type === 1) {
            setDevotionals(res.data?.data || []);
          } else {
                      }
          setLoading(false);
        },
      })
    );
  };

  const filteredDevotionals = devotionals.filter((p) =>
    p.devotionalTitle?.toLowerCase().includes(searchText.toLowerCase()) ||
    p.devotionalDescription?.toLowerCase().includes(searchText.toLowerCase())
  );

  return (
    <div className="flex flex-col">
      {/* Header */}
      <div className="flex justify-between items-center mb-4 gap-2">
        <input
          type="text"
          placeholder="Search Devotionals..."
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          className="w-full px-4 py-2 rounded-xl bg-[#1a1a1a] text-white border border-gray-600 outline-none"
        />
        <ArrowRight
          onClick={onNext}
          className="text-white w-6 h-6 cursor-pointer"
        />
      </div>

      {/* Create New Button */}
      <button
        onClick={onCreatePlan}
        className="mb-6 bg-[#F8BA34] text-black font-semibold py-3 rounded-xl hover:bg-yellow-500 transition shadow-md"
      >
        Create New Devotional
      </button>

      {/* Loading State */}
      {loading && (
        <div className="text-center py-4">
          <p className="text-gray-400">Loading devotionals...</p>
        </div>
      )}

      {/* Category */}
      <div>
        <div className="flex justify-between items-center mb-2">
          <h2 className="text-sm font-semibold text-[#F8BA34]">Select a Devotional</h2>
          <span className="text-[#F8BA34] text-sm cursor-pointer">{">"}</span>
        </div>

        {/* 2 ROW GRID */}
        <div className="grid grid-flow-col grid-rows-2 gap-4 overflow-x-auto pb-2">
          {!loading && filteredDevotionals.length > 0 ? (
            filteredDevotionals.map((devotional, idx) => (
              <DevotionalCard
                key={devotional._id}
                devotional={devotional}
                onAdd={() => onAddPlan(devotional)}
              />
            ))
          ) : (
            !loading && (
              <p className="text-gray-400 text-sm col-span-2">
                No devotionals found
              </p>
            )
          )}
        </div>
      </div>
    </div>
  );
};

export default DevotionalPlan;